import { yupResolver } from "@hookform/resolvers/yup"
import { type Resolver, useForm } from "react-hook-form"
import { number, object, string } from "yup"
import type { IActivityIncomeForm } from "./types"
import { useTranslation } from "react-i18next"

export function useActivityIncomeForm(
  defaultValues?: Partial<IActivityIncomeForm>
) {
  const { t } = useTranslation()
  const schema = object({
    date: string().required(t("global.requiredField", { field: t("date.date") })),
    activity_id: string().required(t("global.requiredField", { field: t("labels.activity") })),
    post_id: string().required(t("global.requiredField", { field: t("labels.post") })),
    amount: number().required(t("global.requiredField", { field: t("labels.amount") })),
    description: string().notRequired(),
  }).required()

  return useForm<IActivityIncomeForm>({
    resolver: yupResolver(schema) as unknown as Resolver<IActivityIncomeForm>,
    defaultValues,
  })
}
